import get from 'lodash/get';
import analyticsConfig from '../../../../server/config/analytics';

export default function parsely(context) {
  const siteConfig = analyticsConfig[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  const parselyConfig = get(siteConfig, 'parsely');
  const { domain } = parselyConfig;

  return `
    <div id="parsely-root" style="display: none">
      <span id="parsely-cfg" data-parsely-site="${domain}"></span>
    </div>
    <script>
      (function(s, p, d) {
      var h=d.location.protocol, i=p+"-"+s,
      e=d.getElementById(i), r=d.getElementById(p+"-root"),
      u=h==="https:"?"d1z2jf7jlzjs58.cloudfront.net"
      :"static."+p+".com";
      if (e) return;
      e = d.createElement(s); e.id = i; e.async = true;
      e.src = h+"//"+u+"/p.js"; r.appendChild(e);
      })("script", "parsely", document);
    </script>
  `;
}



// WEBPACK FOOTER //
// ./src/views/components/analytics/trackers/parsely.js